document.addEventListener("DOMContentLoaded", function () {
  const dropdownLinks = document.querySelectorAll(".new-navi__submenu-link.has-dropdown");

  dropdownLinks.forEach((link) => {
    const dropdown = link.nextElementSibling;

    // Ensure dropdowns are initially open
    dropdown.classList.add("new-navi__dropdown--visible");
    link.classList.add("dropdown-active");

    link.addEventListener("click", function (e) {
      e.preventDefault();

      // Toggle ONLY the clicked dropdown
      dropdown.classList.toggle("new-navi__dropdown--visible");
      this.classList.toggle("dropdown-active");
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".new-navi__sub-menu")) {
      document.querySelectorAll(".new-navi__dropdown").forEach((dropdown) => {
        dropdown.classList.remove("new-navi__dropdown--visible");
      });
      document.querySelectorAll(".new-navi__submenu-link").forEach((link) => {
        link.classList.remove("dropdown-active");
      });
    }
  });
});
